import * as React from 'react'
import 'react-dates/initialize'
import I18n from '../../../core/i18n'
import { IJsonResponse } from '../../../core/JsonApiSerializer'
import { reservationService } from '../../../core/services'
import { Chat, Channels } from './parts'
import { ChatMembersList } from '../../organisms'
import MessageLayout from '../_layouts/messageLayout'
import { IMessage } from 'static/interfaces'

interface IProps {
  user: IJsonResponse
  tour_group: IJsonResponse
  reservation?: IJsonResponse
  users: IJsonResponse
  conversation: any
}

const TourAttend: React.FC<IProps> = props => {
  const { conversation } = props
  const { data: tour_group } = reservationService.getDataFromJson(props.tour_group)
  const _reservation = props.reservation
    ? reservationService.getDataFromJson(props.reservation).data
    : null
  const { data: user } = reservationService.getDataFromJson(props.user)
  const { data: users } = reservationService.getDataFromJson(props.users)
  const agent = users.find(item => item.agent)
  const guests = users.filter(item => item.guest)
  const guide = users.find(item => item.guide)
  const [reservation, setReservation] = React.useState<any>(_reservation)
  const [messageData, setMessageData] = React.useState<{
    messages: IMessage[]
    conversationId: number
  }>({
    messages: [],
    conversationId: conversation.id,
  })

  // チャットを取得する
  const getMessages = async () => {
    const { data: newMessages } = await reservationService.getReservationMessages({
      conversation_id: conversation.id,
    })
    const { data: parsedMessages } = reservationService.getDataFromJson(newMessages)
    setMessageData({
      messages: parsedMessages,
      conversationId: conversation.id,
    })
  }
  React.useEffect(() => {
    getMessages()
  }, [])

  return (
    messageData.conversationId > 0 && (
      <MessageLayout
        user={user}
        host={agent}
        receipt_id={null}
        reservation={reservation}
        tour={tour_group.tour}
        setReservation={setReservation}
        pageName="check_tour"
        Main={
          <Chat
            user={user}
            initMessages={messageData.messages}
            conversationId={messageData.conversationId}
            note={I18n.t('conversation.note_logout')}
          />
        }
        Side={
          <>
            {user.guest && <Channels page="check_tour" user={user} reservation={reservation} />}
            <ChatMembersList guide={guide} guests={guests} agent={agent} />
          </>
        }
      />
    )
  )
}

export default TourAttend
